// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "heading-module--base-text-alt--global--7ffbe";
export var baseTextGlobal = "heading-module--base-text--global--d7816";
export var blockSpacing100 = "heading-module--block-spacing-100--9eaf8";
export var blockSpacing50 = "heading-module--block-spacing-50--ffa88";
export var blockVPadding100 = "heading-module--block-v-padding-100--18e7c";
export var blockVPadding50 = "heading-module--block-v-padding-50--c1677";
export var captionTextGlobal = "heading-module--caption-text--global--f8d21";
export var cmsRenderedContentGlobal = "heading-module--cms-rendered-content--global--5e31d";
export var defaultHSpacingGlobal = "heading-module--default-h-spacing--global--526b2";
export var fadeInAnimation = "heading-module--fadeInAnimation--2aa65";
export var fadeInOnLoadGlobal = "heading-module--fade-in-on-load--global--cb672";
export var fullHeightGlobal = "heading-module--full-height--global--5e36d";
export var fullHeightOmittingNavGlobal = "heading-module--full-height-omitting-nav--global--391b4";
export var heading = "heading-module--heading--ae0b4";
export var headingTextGlobal = "heading-module--heading-text--global--70857";
export var ingressTextGlobal = "heading-module--ingress-text--global--6afd0";
export var linkColorChangeTransitionGlobal = "heading-module--link-color-change-transition--global--7c9cd";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "heading-module--page-heading-text--global--2aae8";
export var paragraphTextGlobal = "heading-module--paragraph-text--global--884e2";
export var subheadingTextGlobal = "heading-module--subheading-text--global--4803c";